module.exports = __webpack_public_path__ + "static/media/chat.02c5106a.svg";